import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from './api';

export const fmt = (n: number) => n.toLocaleString('de-DE');
export const euro = (v: number) => v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

/** Lädt eine Adresse der Schnittstelle; neu laden mit neu(). Ältere Antworten überschreiben neuere nicht. */
export function useDaten<T>(pfad: string | null) {
  const [daten, setDaten] = useState<T | null>(null);
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);
  const zaehler = useRef(0);
  const laden = useCallback(() => {
    if (!pfad) return;
    const nr = ++zaehler.current;
    setLaedt(true);
    api<T>(pfad).then(
      d => { if (nr === zaehler.current) { setDaten(d); setFehler(''); setLaedt(false); } },
      e => { if (nr === zaehler.current) { setFehler((e as Error).message); setLaedt(false); } }
    );
  }, [pfad]);
  useEffect(laden, [laden]);
  return { daten, fehler, laedt, neu: laden };
}

/** Führt eine Aktion des Aktionskatalogs aus. */
export const aktion = <T = Record<string, unknown>>(name: string, daten: unknown) => api<T>(`/api/akquise/aktion/${name}`, { methode: 'POST', daten });

/** Ereignis: Zähler der Seitenleiste und Glocke neu laden (nach einer Aktion, die sie ändert). */
export const ZAEHLER_NEU = 'neuratek:zaehler';
export const zaehlerNeu = () => window.dispatchEvent(new Event(ZAEHLER_NEU));
